import { ADMIN_CENTER_DATA } from '@routes/sidebar/___shared___/api/constants.ts';

export const SHORE_USERS_STEP_TITLE = 'shoreUsers';

export const SHORE_USERS_DATA_PAYLOAD = {
    dataToReturn: [
        ADMIN_CENTER_DATA.SHORE_USERS,
        ADMIN_CENTER_DATA.SHORE_USER_TITLES,
        ADMIN_CENTER_DATA.SHORE_TEAMS,
        ADMIN_CENTER_DATA.COUNTRY,
    ],
};
